import { createContext, useContext } from 'react';
import { FRAME_SIZE } from '../constants/layout';

/** Shell content size (VIS1 data-frame) for components that switch markup, not only CSS. */
const FrameContext = createContext(FRAME_SIZE.WIDE);

export const FrameProvider = FrameContext.Provider;
export const useFrame = () => useContext(FrameContext);
